module.exports = __webpack_public_path__ + "img/50m1.50799bdc.jpg";